import React from 'react';

export const ScrollView = ({ children }: { children: React.ReactNode }) => {
  return children;
};
